import { ArrowRight } from "lucide-react"
import { Button } from "~/components/ui/button"
import { SectionReveal } from "~/components/company/SectionReveal"

interface FinalCTASectionProps {
  onContactClick: () => void
}

export function FinalCTASection({ onContactClick }: FinalCTASectionProps) {
  return (
    <section className="w-full bg-red-50 py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <SectionReveal className="max-w-2xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">Ready to Move Fast?</h2>
            <p className="text-xl text-slate-600">
              If you need to ship your MVP, scale your team, or move faster, we should talk.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onContactClick}
              size="lg"
              className="text-white font-semibold px-8 py-6 hover:opacity-90"
              style={{ backgroundColor: "#ed2132" }}
            >
              Book a Discovery Call
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="border-slate-300 text-slate-900 hover:bg-white px-8 py-6 font-semibold"
            >
              Send Us a Message
            </Button>
          </div>

          <p className="text-slate-600 text-sm">
            Most calls take 20 minutes. You&apos;ll know within that time if we&apos;re a fit.
          </p>
        </SectionReveal>
      </div>
    </section>
  )
}
